import { newE2EPage } from "@stencil/core/testing";

describe("uic-progress-bar", () => {
    it("should render 50% correctly", async () => {
        const page = await newE2EPage({
            html: '<uic-progress-bar value="50"></uic-progress-bar>'
        });

        const component = await page.find("uic-progress-bar");
        await page.waitForChanges();
        expect(component).toMatchSnapshot();
    });

    it("should render 100% with max value correctly", async () => {
        const page = await newE2EPage({
            html: '<uic-progress-bar value="50" max="50"></uic-progress-bar>'
        });

        const component = await page.find("uic-progress-bar");
        await page.waitForChanges();
        expect(component).toMatchSnapshot();
    });

    it("should update when changing the values", async () => {
        const page = await newE2EPage({
            html: '<uic-progress-bar value="50" max="50"></uic-progress-bar>'
        });

        const component = await page.find("uic-progress-bar");

        component.setAttribute("value", 10);
        component.setAttribute("max", 100);

        await page.waitForChanges();
        expect(component).toMatchSnapshot();
    });
});
